import { localUIDictionaries } from '~/modules/dictionaries/data/local-ui-dictionaries.data';
import { StrictMap } from '~/shared/utils/strict-map';
import type { UiDictionaryType } from '~/modules/dictionaries/enums/UiDictionaryType';
import { ApiException } from '~/shared/errors/ApiException';

export const useDictionariesStore = defineStore('dictionaries', () => {
  const dictionaries = shallowReactive(
    new StrictMap<UiDictionaryType, StrictMap<string, string>>(),
  );

  // Метод для не ssr страниц и для совместимости, будет удален
  async function getDictionaryByType(type: UiDictionaryType): Promise<StrictMap<string, string>> {
    if (dictionaries.size !== 0) return dictionaries.strictGet(type);

    await loadDictionaries();
    return dictionaries.strictGet(type);
  }

  function getDictionaryByTypeSync(type: UiDictionaryType): StrictMap<string, string> {
    return dictionaries.strictGet(type);
  }

  async function loadDictionaries() {
    try {
      for (const [type, dict] of localUIDictionaries) {
        dictionaries.set(type as UiDictionaryType, dict);
      }
    } catch (error) {
      if (!(error instanceof ApiException)) {
        throw error;
      }
    }
  }

  // Вызывать в nuxt плагине (что гарантирует инизиализацию стора до его использования)
  async function initStore() {
    // client side init
    if (dictionaries.size !== 0) {
      // strict maps need to init from maps
      for (const [type, dict] of dictionaries) {
        dictionaries.set(type, new StrictMap<string, string>(dict));
      }

      return;
    }

    // server side init
    await loadDictionaries();
  }

  return {
    dictionaries,
    getDictionaryByType,
    getDictionaryByTypeSync,
    loadDictionaries,
    initStore,
  };
});
